import React from "react";
import styles from "./about.module.scss";
import JoImg from "../../static/images/aboutportrait.jpg";

const About = () => {
  return (
    <article className={styles.main}>
      <div>
        <img src={JoImg} alt="The author Jo Sheringham" />
      </div>
      <div className={styles.bio}>
        <h1>Jo Sheringham</h1>
        <p>
          As a scruffy teenager, Jo had no thoughts of writing until at school a
          short story competition deadline loomed. To avoid detention, she
          scrawled something out on scrap paper and forgot all about it. A
          surprise to everyone she did rather well, however she shelved any
          serious thoughts about writing.
        </p>
        <p>
          Years later, inspired by a dream and a popular song she blew away the
          cobwebs and challenged herself to complete a novel in a year. The
          writing flowed, and a story - My Detective Darling - emerged. Perhaps
          she could do this again…
        </p>
        <p>
          Jo loves a good tale and her writing is always informed by her faith.
          Essential to this process is a quiet space, a view of the sky, a hefty
          thesaurus and dictation software.
        </p>
        <p>She lives with her husband in Wiltshire.</p>
      </div>
    </article>
  );
};

export default About;
